module.exports = __webpack_public_path__ + "assets/img/hero-infos.6cc34844.png";